import {isNil} from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Tooltip from 'src/components/tooltip';
import ActionMenuButton from 'shared/components/action-menu-button';
import PdfLink from 'shared/components/action-menu-button/pdf-link';
import ActionButton from 'shared/components/action-menu-button/action-button';
import TextButton from 'src/components/TextButton';

class Bio extends React.Component {
  static propTypes = {
    student: PropTypes.shape({
      gpa: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      hasCoursesOverTenYears: PropTypes.bool,
      bio: PropTypes.string,
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired,
      currentInstitution: PropTypes.shape({
        name: PropTypes.string.isRequired,
        campus: PropTypes.shape({
          _id: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
        }),
      }).isRequired,
      communityCollegeInfo: PropTypes.shape({
        plansToCompleteAssociateDegree: PropTypes.any,
        transferYear: PropTypes.number,
        transferSemester: PropTypes.string,
        intendedMajor: PropTypes.string,
      }).isRequired,
    }),
    onClick: PropTypes.func.isRequired,
  };

  graduationInfoText = () => {
    const {
      student: {communityCollegeInfo},
    } = this.props;

    if (communityCollegeInfo.transferYear && communityCollegeInfo.transferSemester) {
      return `Intending to transfer in ${communityCollegeInfo.transferSemester} of ${communityCollegeInfo.transferYear}`;
    }

    return '';
  };

  render() {
    const {
      student: {
        bio,
        firstName,
        lastName,
        communityCollegeInfo,
        currentInstitution,
        gpa,
        hasCoursesOverTenYears,
      },
      onClick,
      student,
    } = this.props;

    const noGpa = isNil(gpa);

    let tooltipCopy = '';

    if (isNil(gpa)) {
      tooltipCopy =
        'Your GPA appears here once you add grades for 4 courses taken within the last ten years. Colleges on Raise Me require you to meet their min GPA to earn micro-scholarships.';
    } else if (hasCoursesOverTenYears) {
      tooltipCopy =
        'The GPA displayed here reflects only courses taken within the past 10 years and does not include those taken more than 10 years ago';
    }

    return (
      <div className="about-me-info">
        <ActionMenuButton>
          <ActionButton onClick={onClick}>Edit</ActionButton>
          {student && (
            <PdfLink
              filename="raise_me_resume.pdf"
              printInfo={{student}}
              eventName="print-resume-community-college"
            >
              Print Resume
            </PdfLink>
          )}
        </ActionMenuButton>
        <h1 className="about-me-info-name">
          {firstName} {lastName}
        </h1>
        <h2 className="about-me-info-grad-year">{this.graduationInfoText()}</h2>
        {communityCollegeInfo.plansToCompleteAssociateDegree && (
          <h2 className="about-me-info-plans-associate-degree">
            Planning to complete Associate degree
          </h2>
        )}
        <h3 className="about-me-info-school">{currentInstitution.name}</h3>
        {currentInstitution.campus && (
          <h4 className="about-me-info-campus">{currentInstitution.campus.name}</h4>
        )}
        <h2 className="about-me-info-major">Major: {communityCollegeInfo.intendedMajor}</h2>
        {bio ? (
          <p className="about-me-info-bio">{bio}</p>
        ) : (
          <TextButton onClick={onClick}>+ Add a brief description about yourself</TextButton>
        )}
        <Tooltip title={tooltipCopy}>
          <button
            className={`about-me-info-gpa ${noGpa ? 'about-me-info-no-gpa' : ''}`}
            type="button"
            aria-labelledby="about-me-info-gpa-value"
          >
            <span id="about-me-info-gpa-value">{`${noGpa ? '' : gpa} GPA`.trim()}</span>
          </button>
        </Tooltip>
      </div>
    );
  }
}

export default Bio;
